<template>
  <div class="settings-emergency">
    <div class="emergency ma-2">
      <emergency />
    </div>
  </div>
</template>

<script>
import Emergency from '@/components/settings/emergency'
export default {
  name: 'settings-emergency',
  components: {
    Emergency
  }
}
</script>

<style></style>
